// The status pill. tone says how it reads: neutral, ok, warn, bad. The
// pill knows nothing about what a status means; screens map domain values
// to tones in src/tones and pass the result in. Not for non-status labels,
// which are Tag.

import './pill.css'

export function Pill({ tone = 'neutral', dot = true, className = '', children }) {
  return (
    <span className={`ui-pill ui-pill-${tone}${className ? ` ${className}` : ''}`}>
      {dot ? <span className="ui-pill-dot" aria-hidden="true" /> : null}
      {children}
    </span>
  )
}
